import { render, staticRenderFns } from "./packageTypeList.vue?vue&type=template&id=3fe06760&scoped=true&"
import script from "./packageTypeList.vue?vue&type=script&lang=js&"
export * from "./packageTypeList.vue?vue&type=script&lang=js&"
import style0 from "./packageTypeList.vue?vue&type=style&index=0&id=3fe06760&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe06760",
  null
  
)

export default component.exports